import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 12h-18","key":"svg-0"}],["path",{"d":"M6 9l-3 3l3 3","key":"svg-1"}],["path",{"d":"M21 9v6","key":"svg-2"}]]

const IconArrowLeftBar = createReactComponent('outline', 'arrow-left-bar', 'ArrowLeftBar', __iconNode);

export default IconArrowLeftBar;